module.exports = function() {
  return new Worker("/" + "less-transpiler.f33008cc.worker.js");
};